import {
  ModalCenter,
  ModalFullscreen,
  ModalStoneFlexContainer,
  ModalWrapper
} from "./ui"

export * from "./ui"

export const Modal = {
  Wrapper: ModalWrapper,
  Center: ModalCenter,
  StoneFlexContainer: ModalStoneFlexContainer,
  Fullscreen: ModalFullscreen
}
